/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import {
	BackgroundContainer,
	ResponsiveContainer,
	SectionContainer,
	SectionHeading,
	SlimContactCard,
} from "@components/elements";
import { SlimContactCardsSectionFragment } from "@cosmos/hygraph-schema";
import { extractBackgroundContainerProps } from "@components/utils/section.utils";
import { cx } from "@panda/css";
import { VStack } from "@panda/jsx";

export const SlimContactCardsSection = ({
	config,
	cards,
	forceShowPaddingTop,
	forceShowPaddingBottom,
}: SlimContactCardsSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(cards?.length);
	if (!validHeading && !validContent) return null;

	const disablePaddingBlock = !validHeading && cards?.length === 1;
	const disablePaddingBlockStart = disablePaddingBlock && !forceShowPaddingTop;
	const disablePaddingBlockEnd = config?.disablePaddingBottom || (disablePaddingBlock && !forceShowPaddingBottom);

	return (
		<BackgroundContainer {...extractBackgroundContainerProps(config)}>
			<ResponsiveContainer>
				<SectionContainer
					anchorId={config?.anchorId}
					disablePaddingBlockStart={disablePaddingBlockStart}
					disablePaddingBlockEnd={disablePaddingBlockEnd}
				>
					<VStack
						alignItems="stretch"
						gap={{ md: "eds.dimension.96", mdDown: "eds.dimension.80" }}
						className={cx("slim-contact-cards-section")}
					>
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? (
							<VStack
								alignItems="stretch"
								gap={{ md: "eds.dimension.40", mdDown: "eds.dimension.24" }}
								className={cx("slim-contact-cards-stack")}
							>
								{cards?.map((card, i) => (
									<SlimContactCard key={`card-${i}`} {...card} />
								))}
							</VStack>
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
